// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291551/js/" + chunkId + "." + {"44":"435ef93f","225":"23f1fe54","481":"5432081c","486":"a96f9cb4","770":"fb5a1cdb"}[chunkId] + ".0.5602601741234579.chunk.js";
};